import { FC } from 'react';
import { Stack, StackProps } from '@mui/material';
import { BASE_FORM_FIELD_WIDTH } from 'mir-utils/theme/constants';

/**
 * @summary Компонент-обертка для блоков, содержимое которых по ширине должно соответствовать инпутам.
 * Обычный Stack из mui, но с параметром ширины по умолчанию.
 */
export const FieldsWrapper: FC<StackProps> = (stackProps) => {
  return <Stack width={`${BASE_FORM_FIELD_WIDTH}px`} maxWidth="100%" {...stackProps} />;
};
